import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {apiClient} from "../connection/BlinkApiClient";
import {StemDate} from "../../stem-core/time/Date";
import {field} from "../../stem-core/state/StoreField";
import {UserProfile} from "./UserProfileStore";
import type {StoreId} from "../../stem-core/state/State";


@globalStore
export class UserAddress extends BaseStore("UserAddress") {
    static comparator = (a: UserAddress, b: UserAddress) => a.createdAt.getTime() - b.createdAt.getTime();

    @field("UserProfile") user: UserProfile;
    @field(Boolean) isDefault: boolean;
    @field(Date) createdAt: StemDate;
    @field(String) recipientName: string;
    @field(String) streetAddress: string;
    @field(String) city: string;
    @field(String) state: string; // Or region
    @field(String) country: string;
    @field(String) countryCode: string;
    @field(String) postalCode: string; // Only Ireland has non-numerical post codes, for the rest verify extra
    @field(String) phoneNumber: string;

    // TODO deprecate this method
    getRecipientName(): string {
        return this.recipientName;
    }

    toString(): string {
        return this.getAddressLine(this.streetAddress, this.city, this.state, this.postalCode, this.country);
    }

    toUI(): string {
        return this.toString();
    }

    getAddressLine(...args: (string | undefined)[]): string {
        return args.filter(addrItem => addrItem?.trim().length > 0).join(", ");
    }

    static getDefault(): UserAddress | undefined {
        const addresses = this.all();

        return addresses.find(address => address.isDefault) || addresses[0];
    }
}

export async function apiCreateAddress(newAddressDetails: any = {}): Promise<UserAddress> {
    const response = await apiClient.post("/user_addresses/create", newAddressDetails)
    return UserAddress.loadObject(response);
}

export async function apiEditAddress(addressDetails: any = {}): Promise<UserAddress> {
    const response = await apiClient.post("/user_addresses/edit_address", addressDetails);
    return UserAddress.loadObject(response);
}

export async function apiDeleteAddress(userAddressId: StoreId): Promise<UserAddress> {
    const response = await apiClient.post("/user_addresses/delete_address", {userAddressId});
    return UserAddress.loadObject(response);
}
